module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0404-2597228ebb313f701d9e2fab3160be91.jpg";